import { Button } from '@material-ui/core'
import React, { useContext, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import HowBidPopup from '../../../Component/HowBiddingWorks'
import { Copyrightinfo, Logo, FooterLogo } from '../../../utils'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import AuthContext from '../../../Product/context/auth/authContext'
import './Footer.css'
import Footernav from '../../../utils/FooterNavigation/footernav'
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import AnonymousFeedback from '../AnonymousFeedback'
import Popup from '../../../Product/components/organisms/Popup'
function Footer() {
    const contactEmail = global?.storeDetails?.contact_email
    const contactPhone = global?.storeDetails?.phone
    const facebookLink = global?.storeDetails?.facebook
    const twitterLink = global?.storeDetails?.twitter
    const googleLink = global?.storeDetails?.google
    const instagramLink = global?.storeDetails?.instagram
    const categories = global.allCategories
        .sort((a, b) => a.description.localeCompare(b.description))
        .filter((main) => {
            return true
        })

    const [hbid, setHBid] = React.useState(false)
    const [anonymousFrom, setAnonymousForm] = useState(false)

    const { user, isAuthenticated, logout } = useContext(AuthContext)

    const forMobile = useMediaQuery('(max-width:1024px)')

    const isBidDepotProject = global.storeConfigration?.bodyClass?.value === 'BidAuctionDepot'
    const isBargainTheme = document.querySelector('body').classList.contains('bargains')
    return (
        <>
            {isBidDepotProject ? (
                <footer>
                    <div className="footerInner">
                        <div className="mobile-view-footer">
                            {/* Auctions Section */}
                            <Accordion>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography variant="h6">Auctions</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <ul style={{ listStyleType: 'none', padding: 0 }}>
                                        <li>
                                            <NavLink activeClassName="active" to="/contact_us">
                                                Pick Up Location
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink
                                                activeClassName="active"
                                                to={{
                                                    pathname: '/',
                                                    state: {
                                                        scrollTo: 'customContainer',
                                                        triggerScroll: Date.now(),
                                                    },
                                                }}
                                            >
                                                Browse All Auctions
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink
                                                activeClassName="active"
                                                to={{
                                                    pathname: '/',
                                                    state: {
                                                        scrollTo: 'customContainer',
                                                        auc_type: 2,
                                                        triggerScroll: Date.now(),
                                                    },
                                                }}
                                            >
                                                Current Auctions
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink
                                                activeClassName="active"
                                                to={{
                                                    pathname: '/',
                                                    state: {
                                                        scrollTo: 'customContainer',
                                                        auc_type: 1,
                                                        triggerScroll: Date.now(),
                                                    },
                                                }}
                                            >
                                                Upcoming Auctions
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink
                                                activeClassName="active"
                                                to={{
                                                    pathname: '/',
                                                    state: {
                                                        scrollTo: 'customContainer',
                                                        auc_type: '',
                                                        triggerScroll: Date.now(),
                                                    },
                                                }}
                                            >
                                                Past Auctions
                                            </NavLink>
                                        </li>
                                        <br />
                                        <Typography variant="h6" className="secondhalfTit">
                                            CONTACT BID AUCTION DEPOT
                                        </Typography>
                                        <li>
                                            <a
                                                href="mailto:support@bidauctiondepot.com"
                                                className="email-link"
                                            >
                                                support@bidauctiondepot.com
                                            </a>
                                        </li>
                                        <li>
                                            <a href="tel:+5139935252" className="phone-link">
                                                (513) 993-5252
                                            </a>
                                        </li>
                                    </ul>
                                </AccordionDetails>
                            </Accordion>

                            {/* Categories Section */}
                            <Accordion>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography variant="h6">Categories</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <ul style={{ listStyleType: 'none', padding: 0 }}>
                                        {categories.slice(0, 8).map((val) => (
                                            <>
                                                <NavLink
                                                    activeClassName="active"
                                                    to={`/search?cat=${val.id}`}
                                                >
                                                    {val.description}
                                                </NavLink>
                                                <br />
                                            </>
                                        ))}

                                        {/* <br /> */}
                                        <li>
                                            <NavLink activeClassName="active" to="/search">
                                                <b style={{ color: '#ff6503' }}>
                                                    SHOP ALL CATEGORIES
                                                </b>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </AccordionDetails>
                            </Accordion>

                            {/* Resources Section */}
                            <Accordion>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography variant="h6">Resources</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <ul style={{ listStyleType: 'none', padding: 0 }}>
                                        <li>
                                            <NavLink activeClassName="active" to="/how_it_works">
                                                How it Works
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink activeClassName="active" to="/aboutus">
                                                About Us
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink activeClassName="active" to="/contact_us">
                                                Contact Us
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink
                                                activeClassName="active"
                                                to="/product_conditions_returns"
                                            >
                                                Product Conditions and Returns
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink activeClassName="active" to="/faq">
                                                FAQ
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink activeClassName="active" to="/privacy_policy">
                                                Privacy Policy
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink activeClassName="active" to="/termsOfService">
                                                Terms &amp; Conditions
                                            </NavLink>
                                        </li>

                                        <li onClick={() => setAnonymousForm(true)}>
                                            <a className="cursorDecoy">Anonymous Feedback Form</a>
                                        </li>
                                    </ul>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                        <div className="footerLeft_Base">
                            <dl>
                                <dd className="navTitlt">Auctions</dd>
                                <dd>
                                    <NavLink activeClassName="active" to="/contact_us">
                                        Pick Up Location
                                    </NavLink>
                                </dd>
                                <dd>
                                    <NavLink
                                        activeClassName="active"
                                        to={{
                                            pathname: '/',
                                            state: {
                                                scrollTo: 'customContainer',
                                                triggerScroll: Date.now(),
                                            },
                                        }}
                                    >
                                        Browse All Auctions
                                    </NavLink>
                                </dd>
                                <dd>
                                    <NavLink
                                        activeClassName="active"
                                        to={{
                                            pathname: '/',
                                            state: {
                                                scrollTo: 'customContainer',
                                                auc_type: 2,
                                                triggerScroll: Date.now(),
                                            },
                                        }}
                                    >
                                        Current Auctions
                                    </NavLink>
                                </dd>
                                <dd>
                                    <NavLink
                                        activeClassName="active"
                                        to={{
                                            pathname: '/',
                                            state: {
                                                scrollTo: 'customContainer',
                                                auc_type: 1,
                                                triggerScroll: Date.now(),
                                            },
                                        }}
                                    >
                                        Upcoming Auctions
                                    </NavLink>
                                </dd>
                                <dd>
                                    <NavLink
                                        activeClassName="active"
                                        to={{
                                            pathname: '/',
                                            state: {
                                                scrollTo: 'customContainer',
                                                auc_type: '',
                                                triggerScroll: Date.now(),
                                            },
                                        }}
                                    >
                                        Past Auctions
                                    </NavLink>
                                </dd>
                                <dd style={{ height: '25px' }}></dd>
                                <dd className="secondhalfTit">CONTACT BID AUCTION DEPOT</dd>

                                <dd>
                                    <a
                                        href="mailto:support@bidauctiondepot.com"
                                        className="email-link"
                                    >
                                        support@bidauctiondepot.com
                                    </a>
                                </dd>
                                <dd>
                                    <a href="tel:+5139935252" className="phone-link">
                                        (513) 993-5252
                                    </a>
                                </dd>
                            </dl>
                            <dl>
                                <dd className="navTitlt">Categories</dd>
                                {categories.slice(0, 8).map((val) => (
                                    <dd>
                                        <NavLink
                                            activeClassName="active"
                                            to={`/search?cat=${val.id}`}
                                        >
                                            {val.description}
                                        </NavLink>
                                    </dd>
                                ))}

                                <dd className="secondhalfTit">
                                    <NavLink activeClassName="active" to="/search">
                                        SHOP ALL CATEGORIES
                                    </NavLink>
                                </dd>
                            </dl>

                            <dl>
                                <dd className="navTitlt">Resources</dd>
                                <dd>
                                    <NavLink activeClassName="active" to="/how_it_works">
                                        How it Works
                                    </NavLink>
                                </dd>
                                <dd>
                                    <NavLink activeClassName="active" to="/aboutus">
                                        About Us
                                    </NavLink>
                                </dd>
                                <dd>
                                    <NavLink activeClassName="active" to="/contact_us">
                                        Contact Us
                                    </NavLink>
                                </dd>
                                <dd>
                                    <NavLink
                                        activeClassName="active"
                                        to="/product_conditions_returns"
                                    >
                                        Product Conditions and Returns
                                    </NavLink>
                                </dd>
                                <dd>
                                    <NavLink activeClassName="active" to="/faq">
                                        FAQ
                                    </NavLink>
                                </dd>
                                <dd>
                                    <NavLink activeClassName="active" to="/privacy_policy">
                                        Privacy Policy
                                    </NavLink>
                                </dd>
                                <dd>
                                    <NavLink activeClassName="active" to="/termsOfService">
                                        Terms &amp; Conditions
                                    </NavLink>
                                </dd>
                                <dd onClick={() => setAnonymousForm(true)}>
                                    <a className="cursorDecoy">Anonymous Feedback Form</a>
                                </dd>
                            </dl>
                        </div>
                        <div className="footerRight_Base">
                            <FooterLogo className="footerLogo" />
                            <span className="d-md-block">
                                <p className="text-center copyright">
                                    © Copyright 2025{' '}
                                    <span className="fc-name copy-right">Bid Auction Depot</span>
                                </p>
                            </span>

                            <p className="text-center copyright">Follow us on social media!</p>
                            <ul className="footer-main-standard-social-list">
                                {facebookLink && (
                                    <li className="facebook">
                                        <a
                                            href={facebookLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Facebook"
                                        >
                                            <i className="fab fa-facebook"></i>
                                        </a>
                                    </li>
                                )}
                                {twitterLink && (
                                    <li className="pinterest">
                                        <a
                                            href={twitterLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Twitter"
                                        >
                                            <i className="fab fa-twitter"></i>
                                        </a>
                                    </li>
                                )}
                                {googleLink && (
                                    <li className="instagram">
                                        <a
                                            href={googleLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Instagram"
                                        >
                                            <i className="fab fa-linkedin"></i>
                                        </a>
                                    </li>
                                )}
                                {instagramLink && (
                                    <li className="instagram">
                                        <a
                                            href={instagramLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Instagram"
                                        >
                                            <i className="fab fa-instagram"></i>
                                        </a>
                                    </li>
                                )}
                            </ul>
                            <ul className="footer-main-standart-card-list">
                                <li>
                                    <img src="/assets/images/card_visa.png" alt="Visa" />
                                </li>
                                <li>
                                    <img
                                        src="/assets/images/card_mastercard.png"
                                        alt="Mastercard"
                                    />
                                </li>
                                <li>
                                    <img src="/assets/images/card_discover.png" alt="Discover" />
                                </li>
                                <li>
                                    <img
                                        src="/assets/images/card_american_express.png"
                                        alt="American Express"
                                    />
                                </li>
                            </ul>
                        </div>
                    </div>
                    <AnonymousFeedback
                        open={anonymousFrom}
                        handleClose={() => setAnonymousForm(false)}
                    />
                </footer>
            ) : isBargainTheme ? (
                <footer>
                    <div className="footerInner">
                        <div className="mobile-view-footer">
                            {/* Auctions Section */}
                            <Accordion>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography variant="h6">Auctions</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <ul style={{ listStyleType: 'none', padding: 0 }}>
                                        <li>
                                            <NavLink activeClassName="active" to="/contact_us">
                                                Pick Up Location
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink
                                                activeClassName="active"
                                                to={{
                                                    pathname: '/',
                                                    state: {
                                                        scrollTo: 'customContainer',
                                                        triggerScroll: Date.now(),
                                                    },
                                                }}
                                            >
                                                Browse All Auctions
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink
                                                activeClassName="active"
                                                to={{
                                                    pathname: '/',
                                                    state: {
                                                        scrollTo: 'customContainer',
                                                        auc_type: 2,
                                                        triggerScroll: Date.now(),
                                                    },
                                                }}
                                            >
                                                Current Auctions
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink
                                                activeClassName="active"
                                                to={{
                                                    pathname: '/',
                                                    state: {
                                                        scrollTo: 'customContainer',
                                                        auc_type: 1,
                                                        triggerScroll: Date.now(),
                                                    },
                                                }}
                                            >
                                                Upcoming Auctions
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink
                                                activeClassName="active"
                                                to={{
                                                    pathname: '/',
                                                    state: {
                                                        scrollTo: 'customContainer',
                                                        auc_type: '',
                                                        triggerScroll: Date.now(),
                                                    },
                                                }}
                                            >
                                                Past Auctions
                                            </NavLink>
                                        </li>
                                        <br />
                                        {isBargainTheme ? (
                                            <Typography variant="h6" className="secondhalfTit">
                                                CONTACT BARGAIN DEPOT
                                            </Typography>
                                        ) : (
                                            <Typography variant="h6" className="secondhalfTit">
                                                CONTACT BID AUCTION DEPOT
                                            </Typography>
                                        )}
                                        <li>
                                            <a
                                                href="mailto:support@bidauctiondepot.com"
                                                className="email-link"
                                            >
                                                support@bidauctiondepot.com
                                            </a>
                                        </li>
                                        <li>
                                            <a href="tel:+5139935252" className="phone-link">
                                                (513) 993-5252
                                            </a>
                                        </li>
                                    </ul>
                                </AccordionDetails>
                            </Accordion>

                            {/* Categories Section */}
                            <Accordion>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography variant="h6">Categories</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <ul style={{ listStyleType: 'none', padding: 0 }}>
                                        {categories.slice(0, 8).map((val) => (
                                            <>
                                                <NavLink
                                                    activeClassName="active"
                                                    to={`/search?cat=${val.id}`}
                                                >
                                                    {val.description}
                                                </NavLink>
                                                <br />
                                            </>
                                        ))}

                                        {/* <br /> */}
                                        <li>
                                            <NavLink activeClassName="active" to="/search">
                                                <b style={{ color: '#ff6503' }}>
                                                    SHOP ALL CATEGORIES
                                                </b>
                                            </NavLink>
                                        </li>
                                    </ul>
                                </AccordionDetails>
                            </Accordion>

                            {/* Resources Section */}
                            <Accordion>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography variant="h6">Resources</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <ul style={{ listStyleType: 'none', padding: 0 }}>
                                        <li>
                                            <NavLink activeClassName="active" to="/how_it_works">
                                                How it Works
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink activeClassName="active" to="/aboutus">
                                                About Us
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink activeClassName="active" to="/contact_us">
                                                Contact Us
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink
                                                activeClassName="active"
                                                to="/product_conditions_returns"
                                            >
                                                Product Conditions and Returns
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink activeClassName="active" to="/faq">
                                                FAQ
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink activeClassName="active" to="/privacy_policy">
                                                Privacy Policy
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink activeClassName="active" to="/termsOfService">
                                                Terms &amp; Conditions
                                            </NavLink>
                                        </li>

                                        <li onClick={() => setAnonymousForm(true)}>
                                            <a className="cursorDecoy">Anonymous Feedback Form</a>
                                        </li>
                                    </ul>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                        <div className="footerLeft_Base">
                            <dl>
                                <dd className="navTitlt">Contact Bargains Depot</dd>

                                <dd>
                                    <a
                                        href="mailto:support@bargainsdepot.com"
                                        className="email-link"
                                    >
                                        support@bargainsdepot.com
                                    </a>
                                </dd>
                                <dd>
                                    <a href="tel:+5139935252" className="phone-link">
                                        (513) 993-5252
                                    </a>
                                </dd>
                            </dl>

                            <dl>
                                <dd className="navTitlt">Resources</dd>

                                <dd>
                                    <NavLink activeClassName="active" to="/aboutus">
                                        About Us
                                    </NavLink>
                                </dd>
                                <dd>
                                    <NavLink activeClassName="active" to="/contact_us">
                                        Contact Us
                                    </NavLink>
                                </dd>
                                <dd>
                                    <NavLink activeClassName="active" to="/faq">
                                        FAQ
                                    </NavLink>
                                </dd>
                                <dd>
                                    <NavLink activeClassName="active" to="/privacy_policy">
                                        Privacy Policy
                                    </NavLink>
                                </dd>
                                <dd>
                                    <NavLink activeClassName="active" to="/termsOfService">
                                        Terms &amp; Conditions
                                    </NavLink>
                                </dd>
                            </dl>
                        </div>
                        <div className="footerRight_Base">
                            <FooterLogo className="footerLogo" />
                            <span className="d-md-block">
                                <p className="text-center copyright">
                                    © Copyright 2025{' '}
                                    <span className="fc-name copy-right">Bargains Depot</span>
                                </p>
                            </span>

                            <p className="text-center copyright">Follow us on social media!</p>
                            <ul className="footer-main-standard-social-list">
                                {facebookLink && (
                                    <li className="facebook">
                                        <a
                                            href={facebookLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Facebook"
                                        >
                                            <i className="fab fa-facebook"></i>
                                        </a>
                                    </li>
                                )}
                                {twitterLink && (
                                    <li className="pinterest">
                                        <a
                                            href={twitterLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Twitter"
                                        >
                                            <i className="fab fa-twitter"></i>
                                        </a>
                                    </li>
                                )}
                                {googleLink && (
                                    <li className="instagram">
                                        <a
                                            href={googleLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Instagram"
                                        >
                                            <i className="fab fa-linkedin"></i>
                                        </a>
                                    </li>
                                )}
                                {instagramLink && (
                                    <li className="instagram">
                                        <a
                                            href={instagramLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Instagram"
                                        >
                                            <i className="fab fa-instagram"></i>
                                        </a>
                                    </li>
                                )}
                            </ul>

                            {/* <div className="socialButton_Base">
                        <a href="#">
                            <img src="/assets/images/appStore.png" alt="AppStore Link" />
                        </a>
                        <a href="#">
                            <img
                                src="/assets/images/googleStore.png"
                                alt="googleStore Link"
                            />
                        </a>
                    </div> */}
                        </div>
                    </div>
                    <AnonymousFeedback
                        open={anonymousFrom}
                        handleClose={() => setAnonymousForm(false)}
                    />
                </footer>
            ) : (
                <footer className="footer-main-standard noPrint">
                    <div className="customContainer">
                        <div className="row" data-gutter="60">
                            <div className="col-12 ftrDtlCntnr">
                                <div className="footLogoCnt">
                                    <FooterLogo className="footerLogo" />
                                    <span className="d-md-block d-none">
                                        <Copyrightinfo />
                                    </span>
                                </div>
                                <div className="footerMisc">
                                    <ul
                                        id={
                                            global.storeDetails?.footer_theme == '#0d0c0c' ||
                                            global.storeDetails.footer_theme == '#000000'
                                                ? 'change-footer-hov-color'
                                                : ''
                                        }
                                        className="footerLinks"
                                    >
                                        {/* <li onClick={() => setHBid(true)}>
                                            <a className="cursorDecoy">How does bidding work</a>
                                        </li> */}
                                        <li>
                                            <NavLink activeClassName="active" to="/how_it_works">
                                                How It Works
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink activeClassName="active" to="/termsOfService">
                                                Terms & Conditions
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink activeClassName="active" to="/privacy_policy">
                                                Privacy Policy
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink activeClassName="active" to="/faq">
                                                FAQ
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink activeClassName="active" to="/aboutus">
                                                About Us
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink activeClassName="active" to="/contact_us">
                                                Contact Us
                                            </NavLink>
                                        </li>
                                        <Footernav />
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <span className="d-md-none d-block">
                        <Copyrightinfo />
                    </span>
                    <HowBidPopup open={hbid} handleClose={() => setHBid(false)} />
                </footer>
            )}
        </>
    )
}

export default Footer
